import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BuiltInPageItemDataService,
  InstalledAppsPageItemDataService,
  RecentlyWatchedTvPageItemDataService,
  TopTenLiveTvPageItemDataService,
  OtherAppsPageItemDataService,
  VodContentPageItemDataService,
  RecommendedAppsPageItemDataService,
  CurrentlyOnTvPageItemDataService,
  SpotlightPageItemDataService,
  SpotlightItemTypeApiModel,
  ProgramDataService,
  SpotlightDetailApiModel,
  SpotlightItemApiModel,
  VodSpotlightItemApiModel,
  ProgramApiModel,
  SearchTagsPageItemDataService,
  UpcomingLiveTvPageItemDataService,
  FullscreenPageItemDataService,
  BannersCtaPageItemDataService,
  TvChannelLogoPageItemDataService,
  TopTenVodContentPageItemDataService,
  BannersPageItemDataService,
  CollectionsPageItemDataService,
  ChannelSpecificUpcomingPageItemDataService,
  RecommendationPageItemDataService,
  RecommendedChannelsPageItemDataService,
  MarketingBannerPageItemDataService,
  ContentGroupDataService,
  TvSeasonPageItemDataService,
  TvSeasonPageItemApiModel,
  SeasonPageItemDataService,
  SeasonPageItemApiModel,
  MarketingEmailBlockerPageItemDataService,
  MarketingSpotlightCtaPageItemDataService,
  GenrePageItemDataService,
  StudioPageItemDataService,
  CarouselPageItemDataService,
  MarketingHeroPageItemDataService,
  MarketingFaqPageItemDataService,
  MarketingPartnerVoucherPageItemDataService,
  MarketingRedeemCtaPageItemDataService,
  MarketingBulletedUspPageItemDataService,
  MarketingDetailPageItemDataService,
  MarketingDeviceCtaPageItemDataService,
  MarketingPageItemUspDataService,
  MarketingTargetedFaqPageItemDataService,
  HeroDataService,
  MarketingGenericVoucherPageItemDataService,
  MarketingAppLandingPageItemDataService,
  MarketingPageItemKidsDataService,
  MarketingPageItemStudioDataService,
  MarketingPageItemTrendingDataService,
  MarketingPageItemEmailDataService,
  MarketingPageItemCtaDataService,
  ChannelSpecificCatchUpPageItemDataService,
  CatchUpPageItemDataService,
  MarketingPageItemVideoDataService,
  MarketingPageItemBarDataService,
  ContentGroupApiModel,
  FullscreenItemApiModel,
  FullscreenPageItemApiModel,
  OndemandSpotlightItemApiModel,
  ProgramAvailabilityTagApiModel,
  SearchTagsItemApiModel,
  SearchTagsPageItemApiModel,
  LandscapePageItemDataService,
  CategoryPageItemDataService,
  OndemandBannerPageItemDataService,
} from '@cxb/editor-stb-api';
import { firstValueFrom, Observable, of, switchMap, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PageItem } from '../domain/page-item';
import { PageItemType } from '../domain/page-item-type';
import { PageType } from '../page-edit-screen/page-type';
import { PartialFeed } from '../domain/feed';
import { PartialProgram } from '../domain/program';
import { Tenant } from '../domain/tenant';

import { mapApiGenreTrayToDomain, mapApiStudiosTrayToDomain } from './components/generic-tray-form/generic-tray-form.mapping';
import { mapApiCtaToDomain } from './components/marketing-cta-tray-form/marketing-cta-tray-form.mapping';
import { mapApiUspToDomain } from './components/marketing-usp-tray-form/marketing-usp-tray-form.mapping';
import { mapApiMarketingHeroToDomain } from './components/marketing-hero-tray-form/marketing-hero-tray-form.mapping';
import { mapApiDetailedPageMarketingBannerToDomain } from './components/detailed-page-marketing-banner-form/detailed-page-marketing-banner-form.mapper';
import { mapApiRedeemPartnerVoucherTrayToDomain } from './components/redeem-partner-voucher-tray-form/redeem-partner-voucher-tray-form.mapping';
import { mapApiRedeemGenericVoucherTrayToDomain } from './components/redeem-generic-voucher-tray-form/redeem-generic-voucher-tray-form.mapping';
import { mapApiRedeemUspTrayToDomain } from './components/redeem-usp-tray-form/redeem-usp-tray-form.mapping';
import { mapCommonTrayApiModelToDomainModel } from './components/common-tray-form/common-tray-form.mapping';
import { mapApiCollectionTrayToDomain } from './components/collection-tray-form/collection-tray-form.mapping';
import { mapApiFaqTrayToDomain } from './components/faq-tray-form/faq-tray-form.mapping';
import { mapSeasonTrayApiModelToDomainModel } from './components/season-tray-form/season-tray-form.mapping';
import { mapSinglePhotoSeasonTrayApiModelToDomainModel } from './components/single-photo-season-tray-form/single-photo-season-tray-from.mapping';
import { mapHeroSpotlightTrayApiModelToDomainModel, mapHeroTrayApiModelToDomainModel } from './components/hero-editor/hero-editor.mapping';
import { mapRecommendationTrayApiModelToDomainModel } from './components/recommendation-tray-form/recommendation-tray-form.mapping';
import { mapTitleImagePortraitTrayApiModelToDomainModel } from './components/title-image-portrait-tray-form/title-image-portrait-tray-form.mapping';
import { mapStreamingContentTrayApiModelToDomainModel } from './components/streaming-content-tray-form/streaming-content-tray-form.mapping';
import { mapCurrentlyOnTVTrayApiModelToDomainModel } from './components/currently-on-tv-tray-form/currently-on-tv-tray-form.mapping';
import { mapChannelLogoTrayApiModelToDomainModel } from './components/channel-logo-tray-form/channel-logo-tray-form.mapping';
import { mapTopTenOnOSNPlusPosterArtTrayApiModelToDomainModel } from './components/top-ten-on-osn-plus-poster-art-tray-form/top-ten-on-osn-plus-poster-art-tray-form.mapping';
import { mapTopTenOnLiveTVTrayApiModelToDomainModel } from './components/top-ten-on-live-tv-tray-form/top-ten-on-live-tv-tray-form.mapping';
import { mapRecentlyWatchedTVTrayApiModelToDomainModel } from './components/recently-watched-tv-tray-form/recently-watched-tv-tray-form.mapping';
import {
  mapAppsAndGamesInstalledAppsTrayApiModelToDomainModel,
  mapAppsAndGamesRecommendedAppsTrayApiModelToDomainModel,
} from './components/apps-and-games-tray-form/apps-and-games-tray-form.mapping';
import { mapSearchTagsTrayApiModelToDomainModel } from './components/search-tags-tray/search-tags-tray.mapping';
import { mapComingSoonForLiveTVTrayApiModelToDomainModel } from './components/coming-soon-for-live-tv-tray/coming-soon-for-live-tv-tray.mapping';
import { mapFullscreenTrayApiModelToDomainModel } from './components/fullscreen-tray-form/fullscreen-tray-form.mapping';
import { mapBannersTrayWithCtaTrayApiModelToDomainModel } from './components/banners-tray-with-cta/banners-tray-with-cta.mapping';
import { mapNewCarouselTrayApiModelToDomainModel } from './components/new-carousel-tray-form/new-carousel-tray-form.mapping';
import { mapCarouselBannerTrayApiModelToDomainModel } from './components/carousel-banner-tray-form/carousel-banner-tray-form.mapping';
import { mapUpcomingOnSpecificTVChannelTrayApiModelToDomainModel } from './components/upcoming-on-specific-tv-channel-tray-form/upcoming-on-specific-tv-channel-tray-form.mapping';
import { mapRecommendedChannelsTrayApiModelToDomainModel } from './components/recommended-channels-tray/recommended-channels-tray.mapping';
import { mapMarketingBannerTrayApiModelToDomainModel } from './components/marketing-banner-tray-form/marketing-banner-tray-form.mapping';
import { mapMarketingEmailBlockerTrayApiModelToDomainModel } from './components/marketing-email-blocker-tray-form/marketing-email-blocker-tray-form.mapping';
import { mapSpotlightTrayApiModelToDomainModel } from './components/spotlight-tray-form/spotlight-tray-form.mapping';
import { mapApiDeviceModuleTrayToDomain } from './components/device-module-tray-form/device-module-tray-form.mapping';
import { mapApiKidsToDomain } from './components/marketing-kids-tray-form/marketing-kids-tray-form.mapping';
import { mapApiTrendingToDomain } from './components/marketing-trending-tray-form/marketing-trending-tray-form.mapping';
import { mapApiStudioToDomain } from './components/marketing-studio-tray-form/marketing-studio-tray-form.mapping';
import { mapApiEmailCollectorDomain } from './components/marketing-email-collector-tray-form/marketing-email-collector-tray-form.mapping';
import {
  mapCatchUpTrayApiModelToDomainModel,
  mapChannelSpecificCatchUpTrayApiModelToDomainModel,
} from './components/catch-up-tray/catch-up-tray.mapping';
import { mapApiRedeemCtaTrayToDomain } from './components/redeem-cta-tray-form/redeem-cta-tray-form.mapping';
import { mapAppLandingPageItemApiModelToDomainModel } from './components/app-landing-mobile-tray-form/app-landing-mobile-tray-form.mapping';
import { mapBuiltInTrayApiModelToDomainModel } from './components/built-in-tray-form/built-in-tray-form.mapping';
import { mapMarketingVideoTrayApiModelToDomainModel } from './components/marketing-video-tray-form/marketing-video-tray.mapping';
import { mapMarketingBarTrayApiModelToDomainModel } from './components/marketing-bar-tray/marketing-bar-tray-mapping';
import { SpotlightDetailWithProgramApiModel } from './components/hero-editor/components/hero-tray-form/hero-tray-form.view-model';
import { SeasonPageItemWithProgramApiModel } from './components/single-photo-season-tray-form/single-photo-season-tray-form.view-model';
import { mapLandscapeTrayApiModelToDomainModel } from './components/landscape-tray-form/landscape-tray-form.mapping';
import { mapCategoryTrayApiModelToDomainModel } from './components/category-tray-form/category-tray-form.mapping';
import { mapOndemandBannerTrayApiModelToDomainModel } from './components/ondemand-banner-tray-form/ondemand-banner-tray-form.mapping';

@Injectable({ providedIn: 'root' })
export class TrayApiLoadService {
  constructor(
    private readonly marketingHeroDataService: MarketingHeroPageItemDataService,
    private readonly marketingDetailPageItemDataService: MarketingDetailPageItemDataService,
    private readonly uspDataService: MarketingPageItemUspDataService,
    private readonly marketingCtaDataService: MarketingPageItemCtaDataService,
    private readonly carouselDataService: CarouselPageItemDataService,
    private readonly redeemPartnerVoucherTrayDataService: MarketingPartnerVoucherPageItemDataService,
    private readonly redeemGenericVoucherTrayDataService: MarketingGenericVoucherPageItemDataService, // AXB-1175
    private readonly redeemCtaTrayDataService: MarketingRedeemCtaPageItemDataService,
    private readonly redeemUspTrayDataService: MarketingBulletedUspPageItemDataService,
    private readonly faqTrayDataService: MarketingFaqPageItemDataService,
    private readonly targetedFaqTrayDataService: MarketingTargetedFaqPageItemDataService,
    private readonly seasonTrayDataService: TvSeasonPageItemDataService,
    private readonly singlePhotoSeasonTrayDataService: SeasonPageItemDataService,
    private readonly genrePageItemDataService: GenrePageItemDataService,
    private readonly studioPageItemDataService: StudioPageItemDataService,
    private readonly builtInDataService: BuiltInPageItemDataService,
    private readonly installedAppsPageItemDataService: InstalledAppsPageItemDataService,
    private readonly recommendedAppsPageItemDataService: RecommendedAppsPageItemDataService,
    private readonly otherAppsDataService: OtherAppsPageItemDataService,
    private readonly topTenVodContentPageItemDataService: TopTenVodContentPageItemDataService,
    private readonly recentlyWatchedTvPageItemDataService: RecentlyWatchedTvPageItemDataService,
    private readonly topTenLiveTvPageItemDataService: TopTenLiveTvPageItemDataService,
    private readonly currentlyOnTvPageItemDataService: CurrentlyOnTvPageItemDataService,
    private readonly spotlightPageItemDataService: SpotlightPageItemDataService,
    private readonly programDataService: ProgramDataService,
    private readonly contentGroupDataService: ContentGroupDataService,
    private readonly marketingBannerPageItemDataService: MarketingBannerPageItemDataService,
    private readonly searchTagsPageItemDataService: SearchTagsPageItemDataService,
    private readonly tvChannelLogoPageItemDataService: TvChannelLogoPageItemDataService,
    private readonly vodContentPageItemDataService: VodContentPageItemDataService,
    private readonly upcomingLiveTvPageItemDataService: UpcomingLiveTvPageItemDataService,
    private readonly fullscreenPageItemDataService: FullscreenPageItemDataService,
    private readonly bannersCtaPageItemDataService: BannersCtaPageItemDataService,
    private readonly bannersPageItemDataService: BannersPageItemDataService,
    private readonly collectionsPageItemDataService: CollectionsPageItemDataService,
    private readonly channelSpecificUpcomingPageItemDataService: ChannelSpecificUpcomingPageItemDataService,
    private readonly recommendationPageItemDataService: RecommendationPageItemDataService,
    private readonly recommendedChannelsPageItemDataService: RecommendedChannelsPageItemDataService,
    private readonly marketingEmailBlockerPageItemDataService: MarketingEmailBlockerPageItemDataService,
    private readonly spotlightTrayDataService: MarketingSpotlightCtaPageItemDataService,
    private readonly deviceModuleTrayDataService: MarketingDeviceCtaPageItemDataService,
    private readonly heroDataService: HeroDataService,
    private readonly appLandingPageItemDataService: MarketingAppLandingPageItemDataService,
    private readonly kidsDataService: MarketingPageItemKidsDataService,
    private readonly studioDataService: MarketingPageItemStudioDataService,
    private readonly trendingDataService: MarketingPageItemTrendingDataService,
    private readonly marketingEmailDataService: MarketingPageItemEmailDataService,
    private readonly catchUpPageItemDataService: CatchUpPageItemDataService,
    private readonly channelSpecificCatchUpPageItemDataService: ChannelSpecificCatchUpPageItemDataService,
    private readonly marketingPageItemVideoDataService: MarketingPageItemVideoDataService,
    private readonly marketingPageItemBarDataService: MarketingPageItemBarDataService,
    private readonly landscapePageItemDataService: LandscapePageItemDataService,
    private readonly categoryPageItemDataService: CategoryPageItemDataService,
    private readonly ondemandBannerPageItemDataService: OndemandBannerPageItemDataService
  ) {}

  // eslint-disable-next-line sonarjs/cognitive-complexity
  public loadPageItem$(id: string, type: PageItemType, pageType: PageType, selectedTenant?: Tenant): Observable<PageItem> {
    // eslint-disable-next-line sonarjs/max-switch-cases
    switch (type) {
      case 'GenreTray':
        return this.genrePageItemDataService.getGenrePageItem(id, selectedTenant?.id).pipe(map(mapApiGenreTrayToDomain));
      case 'StudiosTray':
        return this.studioPageItemDataService.getStudioPageItem(id, selectedTenant?.id).pipe(map(mapApiStudiosTrayToDomain));
      case 'PortraitTray':
      case 'TopTenTray':
        return this.carouselDataService.getCarouselPageItem(id, selectedTenant?.id).pipe(map(mapCommonTrayApiModelToDomainModel));
      case 'CollectionTray':
        return this.carouselDataService.getCarouselPageItem(id, selectedTenant?.id).pipe(map(mapApiCollectionTrayToDomain));
      case 'MarketingCta':
        return this.marketingCtaDataService.getMarketingPageItemCta(id, selectedTenant?.id).pipe(map(mapApiCtaToDomain));
      case 'MarketingUsp':
        return this.uspDataService.getMarketingPageItemUsp(id, selectedTenant?.id).pipe(map(mapApiUspToDomain));
      case 'AppLandingPageTray':
        return this.appLandingPageItemDataService
          .getMarketingAppLandingPageItem(id, selectedTenant?.id)
          .pipe(map((pageItem) => mapAppLandingPageItemApiModelToDomainModel(pageItem, pageType)));
      case 'MarketingHero':
        return this.marketingHeroDataService.getMarketingHeroPageItem(id, selectedTenant?.id).pipe(map(mapApiMarketingHeroToDomain));
      case 'DetailedPageMarketingBanner':
        return this.marketingDetailPageItemDataService
          .getMarketingDetailPageItem(id, selectedTenant?.id)
          .pipe(map(mapApiDetailedPageMarketingBannerToDomain));
      case 'RedeemCtaTray':
        if (pageType === PageType.redeem) {
          return this.redeemCtaTrayDataService.getMarketingRedeemCtaPageItem(id, selectedTenant?.id).pipe(map(mapApiRedeemCtaTrayToDomain));
        }
        break;
      case 'RedeemUspTray':
        return this.redeemUspTrayDataService.getMarketingBulletedUspPageItem(id, selectedTenant?.id).pipe(map(mapApiRedeemUspTrayToDomain));
      case 'SeasonTray':
        return this.seasonTrayDataService.getTvSeasonPageItem(id, selectedTenant?.id).pipe(
          switchMap(async (seasonTray: TvSeasonPageItemApiModel) => {
            const splitSeriesId = seasonTray.seriesId.split('/');
            const seriesId = splitSeriesId[splitSeriesId.length - 1];

            const responses = await this.loadMPXProgramDataById([{ contentId: seriesId }]);

            return {
              ...seasonTray,
              program: responses.find((resp) => resp?.id === +seriesId),
            };
          }),
          map(mapSeasonTrayApiModelToDomainModel)
        );
      case 'SinglePhotoSeasonTray':
        return this.singlePhotoSeasonTrayDataService.getSeasonPageItem(id, selectedTenant?.id).pipe(
          switchMap(async (seasonTray: SeasonPageItemApiModel) => {
            const splitSeriesId = seasonTray.seriesId.split('/');
            const seriesId = splitSeriesId[splitSeriesId.length - 1];

            const responses = await this.loadMPXProgramDataById([{ contentId: seriesId }]);

            const seasonTrayToReturn: SeasonPageItemWithProgramApiModel = {
              ...seasonTray,
              program: responses.find((resp) => resp?.id === +seriesId),
            };

            return seasonTrayToReturn;
          }),
          map(mapSinglePhotoSeasonTrayApiModelToDomainModel)
        );
      case 'FaqTray':
        return pageType === PageType.redeem
          ? this.faqTrayDataService.getMarketingFaqPageItem(id, selectedTenant?.id).pipe(map(mapApiFaqTrayToDomain))
          : this.targetedFaqTrayDataService.getMarketingTargetedFaqPageItem(id, selectedTenant?.id).pipe(map(mapApiFaqTrayToDomain));

      case 'RedeemPartnerVoucherTray': // AXB-948
        if (pageType === PageType.redeem) {
          return this.redeemPartnerVoucherTrayDataService
            .getMarketingPartnerVoucherPageItem(id, selectedTenant?.id)
            .pipe(map(mapApiRedeemPartnerVoucherTrayToDomain));
        }
        break;
      case 'RedeemGenericVoucherTray': // AXB-1175
        if (pageType === PageType.redeem) {
          return this.redeemGenericVoucherTrayDataService
            .getMarketingGenericVoucherPageItem(id, selectedTenant?.id)
            .pipe(map(mapApiRedeemGenericVoucherTrayToDomain));
        }
        break;
      case 'Hero':
        return this.heroDataService.getHero(id, selectedTenant?.id).pipe(map(mapHeroTrayApiModelToDomainModel));
      // UXB
      case 'Recommendation':
        return this.recommendationPageItemDataService
          .getRecommendationPageItem(id, selectedTenant?.id)
          .pipe(map(mapRecommendationTrayApiModelToDomainModel));
      case 'TitleImagePortraitTray':
        return this.otherAppsDataService
          .getOtherAppsPageItem(id, selectedTenant?.id)
          .pipe(map(mapTitleImagePortraitTrayApiModelToDomainModel));
      case 'StreamingContentTray': // AXB-81
        return this.vodContentPageItemDataService
          .getVodContentPageItem(id, selectedTenant?.id)
          .pipe(map(mapStreamingContentTrayApiModelToDomainModel));
      case 'TopTenOnOSNPlusPosterArtTray':
        return this.topTenVodContentPageItemDataService
          .getTopTenVodContentPageItem(id, selectedTenant?.id)
          .pipe(map(mapTopTenOnOSNPlusPosterArtTrayApiModelToDomainModel));
      case 'CurrentlyOnTvTray':
        return this.currentlyOnTvPageItemDataService
          .getCurrentlyOnTvPageItem(id, selectedTenant?.id)
          .pipe(map(mapCurrentlyOnTVTrayApiModelToDomainModel));
      case 'ChannelLogoTray':
        return this.tvChannelLogoPageItemDataService
          .getTvChannelLogoPageItem(id, selectedTenant?.id)
          .pipe(map(mapChannelLogoTrayApiModelToDomainModel));
      case 'TopTenOnLiveTvTray': //AXB-75
        return this.topTenLiveTvPageItemDataService.getTopTenLiveTvPageItem(id).pipe(map(mapTopTenOnLiveTVTrayApiModelToDomainModel));
      case 'BuiltIn':
        return this.builtInDataService.getBuiltInPageItem(id, selectedTenant?.id).pipe(map(mapBuiltInTrayApiModelToDomainModel));
      case 'AppsAndGamesInstalledApps':
        return this.installedAppsPageItemDataService
          .getInstalledAppsPageItem(id, selectedTenant?.id)
          .pipe(map(mapAppsAndGamesInstalledAppsTrayApiModelToDomainModel));
      case 'AppsAndGamesRecommendedApps':
        return this.recommendedAppsPageItemDataService
          .getRecommendedAppsPageItem(id, selectedTenant?.id)
          .pipe(map(mapAppsAndGamesRecommendedAppsTrayApiModelToDomainModel));
      case 'RecentlyWatchedTV':
        return this.recentlyWatchedTvPageItemDataService
          .getRecentlyWatchedTvPageItem(id, selectedTenant?.id)
          .pipe(map(mapRecentlyWatchedTVTrayApiModelToDomainModel));
      case 'HeroSpotlight':
        return this.spotlightPageItemDataService.getSpotlightPageItem(id, selectedTenant?.id).pipe(
          switchMap(async (heroSpotlightPageItem: SpotlightDetailApiModel) => {
            const { spotlightItems } = heroSpotlightPageItem;

            const usedPrograms = spotlightItems.reduce((filteredSpotlightItems, spotlightItem: SpotlightItemApiModel) => {
              const { spotlightItemType } = spotlightItem;
              if (spotlightItemType === SpotlightItemTypeApiModel.VodSpotlightItemApiModel) {
                return [
                  ...filteredSpotlightItems,
                  {
                    contentId: (spotlightItem as VodSpotlightItemApiModel).contentId,
                    spotlightItemType: ProgramAvailabilityTagApiModel.Streaming,
                  },
                ];
              }

              if (spotlightItemType === SpotlightItemTypeApiModel.OndemandSpotlightItemApiModel) {
                return [
                  ...filteredSpotlightItems,
                  {
                    contentId: (spotlightItem as OndemandSpotlightItemApiModel).contentId,
                    spotlightItemType: ProgramAvailabilityTagApiModel.OnDemand,
                  },
                ];
              }

              if (spotlightItemType === SpotlightItemTypeApiModel.StoreSpotlightItemApiModel) {
                return [
                  ...filteredSpotlightItems,
                  {
                    contentId: (spotlightItem as OndemandSpotlightItemApiModel).contentId,
                    spotlightItemType: ProgramAvailabilityTagApiModel.Tvod,
                  },
                ];
              }
              return filteredSpotlightItems;
            }, []);

            const responses = await this.loadMPXProgramDataById(usedPrograms);

            const extendedSpotlightItems = spotlightItems.map((spotlightItem) => ({
              ...spotlightItem,
              program: (spotlightItem as VodSpotlightItemApiModel).contentId
                ? responses.find((resp) => resp.id === +(spotlightItem as VodSpotlightItemApiModel).contentId)
                : undefined,
            }));

            const spotlightItemsToReturn: SpotlightDetailWithProgramApiModel = {
              ...heroSpotlightPageItem,
              spotlightItems: extendedSpotlightItems,
            };

            return spotlightItemsToReturn;
          }),
          map(mapHeroSpotlightTrayApiModelToDomainModel) //
        );
      case 'SearchTagsTray': //AXB-172
        return this.searchTagsPageItemDataService.getSearchTagsPageItem(id, selectedTenant?.id).pipe(
          switchMap(async (searchTagsTray: SearchTagsPageItemApiModel) => {
            const usedFeedIds: string[] =
              searchTagsTray.items
                ?.map((item: SearchTagsItemApiModel) => {
                  return item.feedId;
                })
                .filter((feedId: string) => feedId !== null && feedId !== undefined) ?? [];

            const responses = await this.loadFeedDataById(usedFeedIds, selectedTenant);

            const extendedItems = searchTagsTray.items.map((item: SearchTagsItemApiModel) => ({
              ...item,
              feed: item.feedId ? responses.find((resp) => resp.id === item.feedId) : undefined,
            }));

            return {
              ...searchTagsTray,
              items: extendedItems,
            };
          }),
          map(mapSearchTagsTrayApiModelToDomainModel) //
        );
      case 'ComingSoonForLiveTvTray': //AXB-74
        return this.upcomingLiveTvPageItemDataService
          .getUpcomingLiveTvPageItem(id, selectedTenant?.id)
          .pipe(map(mapComingSoonForLiveTVTrayApiModelToDomainModel));
      case 'FullscreenTray': // AXB-72
        return this.fullscreenPageItemDataService.getFullscreenPageItem(id, selectedTenant?.id).pipe(
          switchMap(async (fullscreenTray: FullscreenPageItemApiModel) => {
            // Subtype === (OSNPlusContent || LiveTvProgram)
            if (fullscreenTray.items[0].contentId !== null) {
              // programId
              const usedContentIds =
                fullscreenTray.items
                  ?.map((item: FullscreenItemApiModel) => {
                    return { contentId: item.contentId };
                  })
                  .filter((contentId) => contentId !== null && contentId !== undefined) ?? [];
              const responses = await this.loadMPXProgramDataById(usedContentIds);

              const extendedItems = fullscreenTray.items.map((item) => ({
                ...item,
                program: item.contentId ? responses.find((resp) => resp?.id === +item.contentId) : undefined,
              }));

              return {
                ...fullscreenTray,
                items: extendedItems,
              };
            } else {
              // SubType === OSNPlusContentGroup
              const usedFeedIds: string[] =
                fullscreenTray.items
                  ?.map((item: FullscreenItemApiModel) => {
                    return item.feedId;
                  })
                  .filter((feedId: string) => feedId !== null && feedId !== undefined) ?? [];

              const responses = await this.loadFeedDataById(usedFeedIds, selectedTenant);

              const extendedItems = fullscreenTray.items.map((item: FullscreenItemApiModel) => ({
                ...item,
                feed: item.feedId ? responses.find((resp) => resp.id === item.feedId) : undefined,
              }));

              return {
                ...fullscreenTray,
                items: extendedItems,
              };
            }
          }),
          map(mapFullscreenTrayApiModelToDomainModel) //
        );
      case 'BannersTrayWithCta': //AXB-86
        return this.bannersCtaPageItemDataService
          .getBannersWithCtaPageItem(id, selectedTenant?.id)
          .pipe(map(mapBannersTrayWithCtaTrayApiModelToDomainModel));
      case 'CarouselTray': // AXB-87
        return this.bannersPageItemDataService
          .getBannersPageItem(id, selectedTenant?.id)
          .pipe(map(mapNewCarouselTrayApiModelToDomainModel));
      case 'CarouselBannerTray': // AXB-88
        return this.collectionsPageItemDataService
          .getCollectionsPageItem(id, selectedTenant?.id)
          .pipe(map(mapCarouselBannerTrayApiModelToDomainModel));
      case 'UpcomingOnSpecificTvChannelTray': //AXB-83
        return this.channelSpecificUpcomingPageItemDataService
          .getChannelSpecificUpcomingPageItem(id, selectedTenant?.id)
          .pipe(map(mapUpcomingOnSpecificTVChannelTrayApiModelToDomainModel));
      case 'RecommendedChannelsTray': //AXB-194
        return this.recommendedChannelsPageItemDataService
          .getRecommendedChannelsPageItem(id, selectedTenant?.id)
          .pipe(map(mapRecommendedChannelsTrayApiModelToDomainModel));
      case 'MarketingBannerTray': //AXB-330
        return this.marketingBannerPageItemDataService
          .getMarketingBannerPageItem(id, selectedTenant?.id)
          .pipe(map(mapMarketingBannerTrayApiModelToDomainModel));
      case 'MarketingEmailBlocker':
        return this.marketingEmailBlockerPageItemDataService
          .getMarketingEmailBlockerPageItem(id, selectedTenant?.id)
          .pipe(map(mapMarketingEmailBlockerTrayApiModelToDomainModel));
      case 'SpotlightTray':
        return this.spotlightTrayDataService
          .getMarketingSpotlightCtaPageItem(id, selectedTenant?.id)
          .pipe(map(mapSpotlightTrayApiModelToDomainModel));
      case 'DeviceModuleTray':
        return this.deviceModuleTrayDataService
          .getMarketingDeviceCtaPageItem(id, selectedTenant?.id)
          .pipe(map(mapApiDeviceModuleTrayToDomain));
      case 'MarketingKids':
        return this.kidsDataService.getMarketingPageItemKids(id, selectedTenant?.id).pipe(map(mapApiKidsToDomain));
      case 'MarketingTrending':
        return this.trendingDataService.getMarketingPageItemTrending(id, selectedTenant?.id).pipe(map(mapApiTrendingToDomain));
      case 'MarketingStudio':
        return this.studioDataService.getMarketingPageItemStudio(id, selectedTenant?.id).pipe(map(mapApiStudioToDomain));
      case 'MarketingEmailCollector':
        return this.marketingEmailDataService.getMarketingPageItemEmail(id, selectedTenant?.id).pipe(map(mapApiEmailCollectorDomain));
      case 'CatchUpTray':
        return this.catchUpPageItemDataService.getCatchUpPageItem(id, selectedTenant?.id).pipe(map(mapCatchUpTrayApiModelToDomainModel));
      case 'ChannelSpecificCatchUpTray':
        return this.channelSpecificCatchUpPageItemDataService
          .getChannelSpecificCatchUpPageItem(id, selectedTenant?.id)
          .pipe(map(mapChannelSpecificCatchUpTrayApiModelToDomainModel));
      case 'MarketingVideoTray':
        return this.marketingPageItemVideoDataService
          .getMarketingVideoPageItem(id, selectedTenant?.id)
          .pipe(map(mapMarketingVideoTrayApiModelToDomainModel));
      case 'MarketingBarTray':
        return this.marketingPageItemBarDataService
          .getMarketingBarPageItem(id, selectedTenant.id)
          .pipe(map(mapMarketingBarTrayApiModelToDomainModel));
      case 'LandscapeTray':
        return this.landscapePageItemDataService
          .getLandscapePageItem(id, selectedTenant.id)
          .pipe(map(mapLandscapeTrayApiModelToDomainModel));
      case 'OndemandCategoryTray':
        return this.categoryPageItemDataService.getCategoryPageItem(id, selectedTenant.id).pipe(map(mapCategoryTrayApiModelToDomainModel));
      case 'OndemandBannerTray':
        return this.ondemandBannerPageItemDataService
          .getOndemandBannerPageItem(id, selectedTenant.id)
          .pipe(map(mapOndemandBannerTrayApiModelToDomainModel));
    }

    throw Error(`Unknown tray type: [${type}]`);
  }

  private loadMPXProgramDataById(usedPrograms): Promise<PartialProgram[]> {
    const promises = usedPrograms.map(({ contentId, spotlightItemType }) =>
      firstValueFrom(
        this.programDataService.getProgramById(+contentId, spotlightItemType).pipe(
          map((programApiModel: ProgramApiModel) => ({
            id: programApiModel.id,
            idUrl: programApiModel.idUrl,
            title: programApiModel.title,
            availabilityFrom: programApiModel.availabilityFrom,
            availabilityTo: programApiModel.availabilityTo,
            programType: programApiModel.programType,
          })),
          catchError((error: HttpErrorResponse) => {
            if (error.status === HttpStatusCode.NotFound || error.status === HttpStatusCode.BadRequest) {
              return of({
                id: +contentId,
                idUrl: null,
                title: 'NOT AVAILABLE',
                availabilityFrom: null,
                availabilityTo: null,
                mpxNotFound: true,
              });
            }
            throwError(() => error);
          })
        )
      )
    );

    return Promise.all(promises);
  }

  private loadFeedDataById(feedIds: string[] | number[], selectedTenant?: Tenant): Promise<PartialFeed[]> {
    const promises = feedIds.map((feedId: string | number) =>
      firstValueFrom(
        this.contentGroupDataService.getContentGroup(+feedId, selectedTenant?.id).pipe(
          map((contentGroupApiModel: ContentGroupApiModel) => ({
            // TODO:CXBMERGE:AB ContentGroupApiModel.id should be a string
            id: `${contentGroupApiModel.id}`,
            name: contentGroupApiModel.title,
            created: contentGroupApiModel.updated,
            modified: contentGroupApiModel.updated,
            referringPages: contentGroupApiModel.referringPageNames,
          })),
          catchError((error: HttpErrorResponse) => {
            if (error.status === HttpStatusCode.NotFound) {
              return of({
                id: `${feedId}`,
                name: null,
                created: null,
                modified: null,
                referringPages: null,
              });
            }
            throwError(() => error);
          })
        )
      )
    );

    return Promise.all(promises);
  }
}
